/*eslint-disable*/
//disable-sort-imports
//@ts-nocheck

import { To } from 'Link.types'
import { parsePath } from '../../utils/path'

const cache = {}

function resolveTo(to: To): string {
  if (typeof to === 'string') {
    return to
  }

  if (!to.name) {
    if (!to.pathname) {
      throw new Error('Fill in "name" or "pathname"')
    }

    return to.pathname
  }

  if (to.pathname) {
    throw new Error('Cannot specify both "name" and "pathname"')
  }

  return to.name
}

function escapeParamsDescriptors(route: string): string {
  return route.replace(/(\([^)]+\))/g, '')
}

function resolveRoute(route: string, params: object = {}, searchParams: object = {}): string {
  if (route in cache) {
    return cache[route](params, searchParams)
  }
  const path = escapeParamsDescriptors(route)
  cache[route] = function (params: object, searchParams: object) {
    let result = path
    Object.keys(params).forEach(key => {
      const regExp = new RegExp(`:${key}`, 'g')
      result = result.replace(regExp, params[key])
    })
    const parsedPath = parsePath(result)
    const _searchParams = [...parsedPath.searchParams]
    Object.keys(searchParams).forEach(key => {
      _searchParams.push(`${key}=${searchParams[key]}`)
    })
    result = parsedPath.base
    if (_searchParams.length > 0) {
      result = `${result}?${_searchParams.join('&')}`
    }
    if (parsedPath.hash) {
      result = `${result}#${parsedPath.hash}`
    }
    return result
  }
  return cache[route](params, searchParams)
}

export { resolveTo, resolveRoute, escapeParamsDescriptors }
